import axios from 'axios'
const { API_URL = '' } = process.env

// Auth token is set as the raw default header by initializeApp; UMS and the
// node services verify the bare JWT, never a "Bearer " form.
const authRequest = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export default authRequest
